import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/reducers";

export const store = configureStore({
    reducer: {
        auth: authReducer,
    }
})